module.exports = __webpack_public_path__ + "img/img_aboutus_logo@2x.ec7524ee.png";